<template>
  <v-card>
    <v-tabs
      v-model="tab"
      background-color="blue-grey lighten-5"
    >
      <v-tab key="trader_configs">Configs</v-tab>
      <v-tab key="trader_orders">Orders</v-tab>
      <v-tab key="trader_offers">Offers</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" class="mt-4">
      <v-tab-item key="trader_configs">
        <r-trader-config-page/>
      </v-tab-item>
      <v-tab-item key="trader_orders">
        <r-trader-order-page/>
      </v-tab-item>
      <v-tab-item key="trader_offers">
        <r-trader-offer-page/>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>

import RTraderConfigPage from "@/modules/redactor/views/trader/r-trader-config-page";
import RTraderOfferPage from "@/modules/redactor/views/trader/r-trader-offer-page";
import RTraderOrderPage from "@/modules/redactor/views/trader/r-trader-order-page";

export default {
  name: "r-trader-page",
  components: {RTraderOrderPage, RTraderOfferPage, RTraderConfigPage},
  data: () => ({
    tab: null
  })
}
</script>
